<div class="w-100 d-flex p-medium">
  <p class="c-1 text-onback-high">
    مطالعه
    <span
      class="text-onback-brand"
      (click)="agreementView(pdfType.PROSPECTUS)"
      >امیدنامه
    </span>
    @if (assetSymbol() === '11421' || assetSymbol() === '11394' || assetSymbol() === '10883') {
      ،
    } @else {
      و
    }
    <span
      class="text-onback-brand"
      (click)="agreementView(pdfType.STATUTE)"
      >اساسنامه
    </span>
    @if (assetSymbol() === '11421' || assetSymbol() === '11394' || assetSymbol() === '10883') {
      و
      <span
        class="text-onback-brand"
        (click)="agreementView(pdfType.CONTRACT)"
      >
        قرارداد دیجی‌پی
      </span>
    }
  </p>
</div>
